module.exports = __webpack_public_path__ + "img/logo-ninety.9a4514f4.png";